import script from "./ManageSubscriptionSettingTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageSubscriptionSettingTab.vue?vue&type=script&setup=true&lang=js"

import "./ManageSubscriptionSettingTab.vue?vue&type=style&index=0&id=1df4d10a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df4d10a"]])

export default __exports__